import { z } from 'zod';

export const CorrectVehiclePlateBodySchema = z.object({
  newPlate: z.string().trim().min(1),
  reason: z.string().trim().min(1),
});

export type CorrectVehiclePlateBody = z.infer<typeof CorrectVehiclePlateBodySchema>;

export const CorrectVehiclePlateResponseSchema = z.object({
  customerVehicleId: z.uuid(),
});

export type CorrectVehiclePlateResponse = z.infer<typeof CorrectVehiclePlateResponseSchema>;
